/**
 * Turbo Submit Protection
 *
 * Prevents double-submission of Turbo forms by disabling submit buttons
 * between turbo:submit-start and turbo:submit-end. This protects against
 * double-clicks and clicks on a sibling submit button that would otherwise
 * fire duplicate requests.
 *
 * Uses form.elements rather than form.querySelectorAll so buttons linked to
 * the form via the form="..." attribute are covered even when they live
 * outside the form's DOM subtree (e.g. a modal footer rendered separately
 * from the form itself).
 */

function submitButtonsFor(form: HTMLFormElement): (HTMLInputElement | HTMLButtonElement)[] {
  return Array.from(form.elements).filter(
    (element): element is HTMLInputElement | HTMLButtonElement =>
      (element instanceof HTMLInputElement || element instanceof HTMLButtonElement) &&
      element.type === "submit"
  )
}

document.addEventListener("turbo:submit-start", ((event: CustomEvent) => {
  const form = event.detail.formSubmission.formElement as HTMLFormElement
  for (const button of submitButtonsFor(form)) {
    button.disabled = true
  }
}) as EventListener)

document.addEventListener("turbo:submit-end", ((event: CustomEvent) => {
  const form = event.detail.formSubmission.formElement as HTMLFormElement
  for (const button of submitButtonsFor(form)) {
    button.disabled = false
  }
}) as EventListener)
